import { KameleoonExperiments, KameleoonVariants } from '@/hooks/kameleoon/kameleoonExperiments';
import { useExperimentBase } from '@/hooks/kameleoon/utils/useExperimentBase';

const useIsInReservePriceStatusExperiment = () =>
    useExperimentBase(KameleoonExperiments.ReservePriceStatus, KameleoonVariants.ReservePriceStatus.On);

const useHasReservePriceStatusControl = () =>
    useExperimentBase(KameleoonExperiments.ReservePriceStatus, KameleoonVariants.ReservePriceStatus.Control);

const useIsNotInReservePriceStatusExperiment = () =>
    useExperimentBase(KameleoonExperiments.ReservePriceStatus, KameleoonVariants.ReservePriceStatus.Off);

export const useReservePriceStatusExperiment = () => {
    const hasReservePriceStatusVariant = useIsInReservePriceStatusExperiment();
    useHasReservePriceStatusControl();
    useIsNotInReservePriceStatusExperiment();
    return hasReservePriceStatusVariant;
};
